import apiManager from './apiManager'

const getNotifications = async () => {
	try {
		const response = await apiManager.axios.get('/v1/admin/notification')
		const data = response.data.data

		// Ensure both "incident" and "user" exist, default to 0 if missing
		const notificationsMap = {}
		data.notifications.forEach((item) => {
			notificationsMap[item.type] = item.count
		})

		return {
			status: 200,
			data: {
				notifications: [
					{ type: 'incident', count: notificationsMap.incident || 0 },
					{ type: 'user', count: notificationsMap.user || 0 },
				],
			},
		}
	} catch (err) {
		return {
			status: err.response?.status || 500,
		}
	}
}
const listNotifications = async (type, userId) => {
	const getNotificationData = apiManager.axios
		.get(`/v1/admin/notification/${userId}?type=${type}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return getNotificationData
}

const markAsRead = async (notificationId) => {
	const readNotification = apiManager.axios
		.patch(`/v1/admin/notification/${notificationId}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return readNotification
}

export default {
	getNotifications,
	listNotifications,
	markAsRead,
}
